<template>
  <path pid="0" d="M11.3 22.7a3 3 0 004.24 0l7.17-7.17a3 3 0 000-4.23l-8.59-8.59a1 1 0 00-.71-.29h-10a1 1 0 00-1 1v10a1 1 0 00.3.7zM4.41 4.42H13l8.3 8.29a1 1 0 010 1.41l-7.17 7.17a1 1 0 01-.71.29 1 1 0 01-.71-.29L4.41 13z"/>
</template>
